import { render, staticRenderFns } from "./showdataviews.vue?vue&type=template&id=69859dab"
import script from "./showdataviews.vue?vue&type=script&lang=js"
export * from "./showdataviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports